import { Ng2StateDeclaration } from '@uirouter/angular';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    AdminAuditLogComponent,
} from '@client/app/feature-modules/admin/modules/admin-audit-log/components/audit-log/audit-log.component';
import { Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Injectable({ providedIn: 'root' })
export class AuditLogAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('audit_log')) {
            return true;
        }
        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}

export const AdminAuditLogStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.audit-log',
        url: '/log?page&page_size&module&domain_id&user_id&from&to&sort_by&sort_dir',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
            module: {
                dynamic: true,
                value: 'all',
            },
            domain_id: {
                dynamic: true,
                value: 'all',
            },
            user_id: {
                dynamic: true,
                value: 'all',
            },
            from: {
                dynamic: true,
                value: '',
            },
            to: {
                dynamic: true,
                value: '',
            },
            sort_by: {
                dynamic: true,
                value: 'created_at',
            },
            sort_dir: {
                dynamic: true,
                value: 'desc',
            },
        },
        redirectTo: paginationUrlQueryParamsValidator('base.customer.admin.audit-log'),
        resolve: [
            {
                token: 'auditLogAccess',
                deps: [AuditLogAccessGuard, Transition],
                resolveFn: (guard: AuditLogAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
        component: AdminAuditLogComponent,
        data: { title: 'Acquia Web Governance - Audit Log' },
    },
];
